export enum FlightTimeRange {
    min = 0,
    max = 1440,
}
